import { createApp } from 'vue';
import App from './App.vue';

import '@/styles/index.scss';

const app = createApp(App);

// 按需引入ele组件
// Element Plus
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import '@/utils/element-plus/index.scss';
import '@/styles/global/el-styles.scss';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
app.use(ElementPlus, {
  locale: zhCn,
});
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 按需引入ant组件
import 'ant-design-vue/dist/antd.css';
import { Badge } from 'ant-design-vue';
app.use(Badge);

// pinia
import { createPinia } from 'pinia';
const pinia = createPinia();
app.use(pinia);
// 路由
import router from './router';
app.use(router);

import contextmenu from 'v-contextmenu';
import 'v-contextmenu/dist/themes/default.css';

app.use(contextmenu);

import axios from 'axios';
app.provide('$axios', axios);

app.mount('#app');
